import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'

// Internal components
import Button from '../Button/Button'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const FormItemRoute = (props) => {
  const { item, onFormRouteChange, onFormRouteSkipValidate } = props

  const userContext = useContext(UserContext)
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const changeFormRoute = (e) => {
    e.preventDefault()
    if (item.skipValidation) {
      onFormRouteSkipValidate(true)
      onFormRouteChange(item.value)
    } else {
      onFormRouteChange(item.value)
    }
  }

  return (
    <div className="FormItem FormItem--route">
      <Button
        icon={item.icon}
        label={t(item.transl)}
        modifiers={[item.modifier ? `Button--${item.modifier}` : 'Button--formItemRoute']}
        onClick={(e) => {
          changeFormRoute(e)
        }}
      />
    </div>
  )
}

FormItemRoute.propTypes = {
  item: PropTypes.object,
  onFormRouteChange: PropTypes.func,
  onFormRouteSkipValidate: PropTypes.func
}

export default FormItemRoute
